import React from 'react'
import styled from 'styled-components';
import { TaskListThreeDotsButton, AddButton } from '../general_components/content_management/reusableItems/buttons';
import {NoteObject } from './teamCard/truckCard/truckCardComponents/notesSection';
import { Form } from '../general_components/forms/Form';
import { addPopup } from '../supplementary_components/store';
import { API_ROOT, sendRequest } from '../supplementary_components/requests';
import cloneDeep from 'lodash/cloneDeep';
import { ConfirmationDialogue } from '../general_components/forms/ConfirmationDialogue';
import { useBoardStore } from './boardStore';


const MainBoardNotesWrapper = styled.div`
    width:100%;
    // min-height:5.5rem;
    background-color:var(--extra-light-gray);
    margin-bottom:0.2rem;
    &>.noteList{
        display:flex;
        flex-flow:wrap;
        -webkit-box-align:center;
        align-items:center;
        -webkit-box-pack:start;
        justify-content:flex-start;
        padding:0.8rem 0.4rem 0 0.4rem;
        &>div{
            position:relative;
                &>div{
                    &:first-child{
                        padding-right:1rem;
                    }
                    :nth-child(2){
                        right:0;
                        
                    }
                }
            
        }
    }
    &>.addNewNoteWrapper{
        padding: 0 0 0.4rem 0;
    }
`
const InputFormData = {
    name: "mainBoardNote",
    formTitle: "Add Main Board Note",
    customSubmitButton:"Add Note",
    addLink: API_ROOT+"companies/addBoardNote",
    customMethod:"PATCH",
    successMessage:'Note was added',
    buildRequestBody:(val)=>{
        val.version = "v1";
        val.authorId = parseInt(localStorage.getItem('currentUserId'));
        val.authorName = localStorage.getItem('currentUserFirstName');
        val.relevant = true;
        val.lastChangedBy = null;
        return val;
        
    },
    columns: [
        {
            label: "Note Message",
            name: 'noteMessage',
            autoComplete:"off",
            mandatory: true,
        },
        {
            label: "Urgency",
            name:"urgent",
            type: 'select',
            dataset: ["Not Urgent", "Urgent"],
            processBeforeSending : val => {
                return val === "Urgent";
            }
        },
    ]
}
export const MainBoardNotes = () => {
    const list = useBoardStore(s => s.boardNotes) || [];
    return <MainBoardNotesWrapper>
        <div className="noteList">{
            list.map((note, index)=>{
                // $customBackgroundColor="#FEFEFE"
                return <div key={note?.id || index}>
                    <NoteObject $urgent={note.urgent} $customBorderColor={note.urgent ? "var(--alert-background)" : "var(--lighter-gray)"}  $customVerticalPadding="0.3rem" >
                                {note.noteMessage}
                    </NoteObject>
                    <TaskListThreeDotsButton 
                        position={"absolute"} 
                        top={'0.15rem'} 
                        vertical={true} 
                        customBackgroundColor="var(--extra-light-gray)"
                        customThreeDotsColor={note.urgent ? "var(--alertTextColor)" : null}
                        onRemove={()=>{
                            addPopup({
                                content:ConfirmationDialogue, 
                                popupData: {
                                    action:(postResultAction)=>{
                                        sendRequest("PATCH", API_ROOT+"companies/removeBoardNote", null, ()=>{
                                            //success
                                            postResultAction(true);
                                        }, ()=>{
                                            //error
                                            postResultAction(false);
                                        }, note);
                                    },
                                    name:"Confirm",
                                    formTitle:"Remove Note",
                                    submitTitle:"Remove",
                                    method:"PATCH",
                                    message:"Are you sure you want to remove this note?"
                                }, 
                                postSuccessAction: ()=>{
                                }, 
                                EZCloseAllowed:true
                            })
                        }}
                        onEdit={()=>{
                            const duplicate = cloneDeep(InputFormData);
                            duplicate.addLink = API_ROOT+"companies/updateBoardNote";
                            duplicate.formTitle = "Edit Main Board Note";
                            duplicate.customSubmitButton = "Edit Note";
                            duplicate.successMessage = "Note was Edited";
                            duplicate.columns[0]["defaultValue"] = ()=>{return note.noteMessage}
                            duplicate.columns[1]["defaultValue"] = ()=>{return note.urgent ? "Urgent" : "Not Urgent"}
                            duplicate.columns.push({
                                label: "Note Message",
                                name: 'id',
                                hiddenField:true,
                                defaultValue : ()=>{return note.id}
                            })                                
                            addPopup({content:Form, popupData:{configuration: duplicate}, postSuccessAction: ()=>{}, EZCloseAllowed:true});
                        }}
                    />
                </div>
            })
        }</div>
        <div className="addNewNoteWrapper">
            <AddButton customSize={"1.2rem"} action={()=>{
                addPopup({content:Form, popupData:{configuration: InputFormData}, postSuccessAction: ()=>{}, EZCloseAllowed:true})
            }} />
        </div>

    </MainBoardNotesWrapper>
}
